import {
  AssistanceResponseNoButton,
  AssistanceResponseThumbDownButtonProps,
} from '@modules/oracle/components/AssistanceResponseNoButton/AssistanceResponseNoButton';
import {
  useFlagAssistantResponse,
  useGetPromptPosition,
} from '@modules/oracle/hooks';
import { OracleSearchActionType } from '@modules/oracle/store/oracleActionType';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { trackWisdomEvents } from '@modules/oracle/utils/trackWisdomEvents';
import { IconButtonProps } from '@mui/material';

interface OracleSearchThumbDownButtonProps extends IconButtonProps {
  responseID: string;
}

export function OracleSearchNoButton({
  responseID,
}: OracleSearchThumbDownButtonProps) {
  const dispatch = useOracleSearchStore(({ dispatch }) => dispatch);
  const sessionID = useOracleSearchStore(({ data }) => data.sessionID);
  const dislikeSet = useOracleSearchStore(({ visual }) => visual.dislikeSet);
  const viewToken = useOracleSearchStore(({ data }) => data.chat?.viewToken);
  const [flagAssistantResponse] = useFlagAssistantResponse();
  const isResponseNo = dislikeSet.has(responseID);
  const threadPosition = useGetPromptPosition(responseID);

  const onFeedbackSubmit: AssistanceResponseThumbDownButtonProps['onFeedbackSubmit'] =
    async (comments: string, selectedOptions: string[]) => {
      await flagAssistantResponse({
        responseID,
        comments,
        reasons: selectedOptions,
        isResponseGood: false,
        viewToken,
        sessionID,
      });

      dispatch({
        type: OracleSearchActionType.SET_VISUAL,
        payload: {
          dislikeSet: new Set([...dislikeSet, responseID]),
        },
      });

      trackWisdomEvents({
        eventName: 'Wisdom - Feedback',
        sessionID,
        responseID,
        threadPosition,
        isThumbUp: false,
      });
    };

  return (
    <AssistanceResponseNoButton
      responseID={responseID}
      onFeedbackSubmit={onFeedbackSubmit}
      disabled={isResponseNo}
      size="small"
      sx={{
        color: !isResponseNo ? 'primary.main' : 'text.secondary',
      }}
    />
  );
}
